var config = {
    zfcg:[
        { ico: '&#xe60e;', name: '公开招标',url:'/tenderagent/index.html/#/bidding/project/zfcg/form?type=2' },
        { ico: '&#xe65e;', name: '邀请招标',url:'/tenderagent/index.html/#/bidding/project/zfcg/form?type=4' },
        { ico: '&#xe6e4;', name: '竞争性谈判',url:'/tenderagent/index.html/#/bidding/project/zfcg/form?type=3' },
        { ico: '&#xe607;', name: '竞争性磋商',url:'/tenderagent/index.html/#/bidding/project/zfcg/form?type=6' },
        { ico: '&#xe6a3;', name: '询价采购',url:'/tenderagent/index.html/#/bidding/project/zfcg/form?type=5' },
        { ico: '&#xe627;', name: '单一来源',url:'/tenderagent/index.html/#/bidding/project/zfcg/form?type=7' },
    ],
    zxcg:[
        { ico: '&#xe60e;', name: '公开招标',url:'/otc/index.html#/agency/project/form?type=2&zbr=keda' },
        // { ico: '&#xe65e;', name: '邀请招标',url:'/otc/index.html#/agency/project/form?type=4' },
        // { ico: '&#xe6e4;', name: '谈判采购',url:'/otc/index.html#/agency/project/form?type=3' },
        // { ico: '&#xe607;', name: '竞争性磋商',url:'/otc/index.html#/agency/project/form?type=6' },
        { ico: '&#xe6a3;', name: '询比采购',url:'/otc/index.html#/agency/project/form?type=5&zbr=keda'},
        { ico: '&#xe627;', name: '直接(单一)采购',url:'/otc/index.html#/agency/project/form?type=7&zbr=keda' },
        { ico: '&#xe625;', name: '询比采购(无评审)',url:'/otc/index.html#/agency/project/form?type=8&zbr=keda' },
    ],
    xxcg:[
        { ico: '&#xe60e;', name: '公开招标',url:'/otc/index.html#/agency/project/form?type=2&zbr=keda' },
        { ico: '&#xe65e;', name: '邀请招标',url:'/otc/index.html#/agency/project/form?type=4&zbr=keda' },
        { ico: '&#xe6e4;', name: '谈判采购',url:'/otc/index.html#/agency/project/form?type=3&zbr=keda' },
        { ico: '&#xe607;', name: '竞争性磋商',url:'/otc/index.html#/agency/project/form?type=6&zbr=keda' },
        { ico: '&#xe6a3;', name: '询比采购',url:'/otc/index.html#/agency/project/form?type=5&zbr=keda'},
        { ico: '&#xe627;', name: '直接(单一)采购',url:'/otc/index.html#/agency/project/form?type=7&zbr=keda' },
        { ico: '&#xe625;', name: '询比采购(无评审)',url:'/otc/index.html#/agency/project/form?type=8&zbr=keda' },
    ]
}

export var configExt3 = config;

export function getExt3(key) {
    return (
        config.filter(item => {
            return item.key === key;
        })[0] || {
            value: '无'
        }
    ).value
}
